import { toTitleCase } from '@/functions/toTitleCase';
import { TestType } from '@/types/TestReview';
import FsumHome from '@/views/FsumHome.vue';
import StudentRecord from '@/views/StudentRecord.vue';
import TestSessionReview from '@/views/TestSessionReview.vue';
import StudentSearch from '@/views/StudentSearch.vue';
import NotFound from '@/views/NotFound.vue';
import PassRateReport from '@/views/PassRateReport.vue';
import ClassOverview from '@/views/ClassOverview.vue';
import { defaultPart, availableParts } from '@/types/Certificate';

/**
 * requiresSchool - If true, the user must be logged in and have a school selected.
 * maintainRouteOnSchoolChange - If true, the current route will be unaffected when the school changes.
 * parts - If specified, the route is only available for the given parts.
 */
export default [
    {
        path: '/',
        name: 'default',
        meta: { requiresSchool: true, maintainRouteOnSchoolChange: false },
        component: FsumHome,
        children: [
            {
                path: 'pass-rate-report',
                name: 'passRateReport',
                component: PassRateReport,
                meta: { slugless: true, displayName: 'Pass Rate Report', parts: [defaultPart] },
            },
            {
                path: 'student-search',
                name: 'studentSearch',
                component: StudentSearch,
                props: { onSearchPage: true },
                meta: { slugless: true, displayName: 'Student Search', parts: availableParts },
            },
            {
                path: 'student-search/results',
                name: 'studentSearchResults',
                component: StudentSearch,
                props: { onSearchPage: false },
                meta: { slugless: true, displayName: 'Student Search Results', parts: availableParts },
            },
        ],
    },
    {
        path: '/schools/:schoolSlug/part/:part/courses/:courseAcronym/rating/:ratingAcronym',
        name: 'home',
        component: FsumHome,
        meta: { requiresSchool: true },
        props: true,
        children: [
            {
                path: 'class-overview',
                name: 'classOverview',
                component: ClassOverview,
                meta: { displayName: 'Class Overview' },
            },
            {
                path: 'student/:cusId',
                name: 'studentRecord',
                component: StudentRecord,
                props: true,
                meta: { displayName: 'Student Record', maintainRouteOnSchoolChange: false },
            },
            {
                path: 'student/:cusId/test-review/:testType/:testId',
                name: 'testReview',
                component: TestSessionReview,
                props: ({ params }: {
                    params: {
                        cusId: string,
                        testId: string,
                        testType: string,
                    }
                }) => (
                    {
                        testId: Number.parseInt(params.testId || '0', 10),
                        testType: TestType[toTitleCase(params.testType) as keyof typeof TestType],
                        cusId: Number.parseInt(params.cusId || '0', 10),
                    }
                ),

                meta: { displayName: 'Test Review' },
            },
        ],
    },
    // Catch-all route that will match all paths
    {
        path: '/:pathMatch(.*)*',
        name: 'NotFound',
        component: NotFound,
    },
];
